import { useState, useEffect } from 'react';
import ready from 'document-ready';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import { useTheme } from '@mui/material/styles';
import PaymentAuthorizationSubmitButtons from '@Components/Shared/Payments/PaymentAuthorizationSubmitButtons';

const StripeForm = (props) => {
    
    const [render, setRender] = useState(false);
    const [stripeObject, setStripeObject] = useState(null);
    const [cardObject, setCardObject] = useState(null);

    const theme = useTheme();

    const getColorPalette = () => {
        if (theme.palette.mode == 'dark') {
            return {
                foreground: '#ffffff',
                placeholder: '#999999'
            };
        }
        else {
            return {
                foreground: '#32325d',
                placeholder: '#aab7c4'
            };
        }
    };

    useEffect(() => {
        ready(() => {
            let stripe = Stripe(props.PublicKey, { stripeAccount: props.LoginID });
            let colorPalette = getColorPalette();
            // styling
            let style = {
                base: {
                    color: colorPalette.foreground,
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: colorPalette.placeholder
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            };

            // setup card element
            let elements = stripe.elements();
            let cardElement = elements.create('card',
                {
                    'style': style
                });
            cardElement.mount('#card-element');

            // handle real-time validation errors from the card Element
            cardElement.addEventListener('change', function (event) {
                if (event.error) {
                    console.log(event?.error?.message);
                    props.setError('There was an issue with the card information you entered. Please check your card information and try again.');
                } else {
                    props.setError('');
                }
            });
           
            setStripeObject(stripe);
            setCardObject(cardElement);

            setRender(true);
            props.ready?.();
        });
    }, []);

    const submitForm = () => {
        if (!props.loading) {
            props.validateForm(requestCardToken)
        }
    };

    const requestCardToken = () => {
        props.setLoading(true);

        stripeObject?.confirmCardSetup(props.StripeSecret, {
            payment_method: {
                card: cardObject,
                billing_details: props.StripeContact
            }
        }).then((result) => {
            if (result.error) {
                props.setError('There was an issue with the card information you entered. Please check your card information and try again.');
                console.log(result.error);
                props.setLoading(false);
            }
            else {
                let fullResponse = { ...props };
                fullResponse.PaymentMethodID = result.setupIntent.payment_method;
                props.success?.(fullResponse);
            }
        });
    };

    return (
        <div>
            {props.loading && <LoadingRing sxBox={{ 'justify-content': 'center' }} />}
            <form id='payment-form' className={render ? '' : 'hide'}>
                <div className="stripe-container">
                    <div id="card-element" className="StripeElement">
                    </div>
                </div>
                <div id='credit-card-error' className="error" style={{ textAlign: 'center', marginBottom: '15px' }}>
                    {props.error && <>{props.error}</>}
                </div>
                <PaymentAuthorizationSubmitButtons
                    {...props}
                    submitForm={submitForm}
                />
            </form>
        </div>
    );
}

export default StripeForm;